import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'translate';

import StyledSignAndLogin from './styles/SignAndLogin.styles';

import WarningIcon from '../../../../icons/pay-it-forward/Warning.svg';


const SignAndLogin = ({ className, onClick }) => (
  <StyledSignAndLogin className={className}>
    <img src={WarningIcon} alt={WarningIcon} />
    <div>
      &nbsp;<FormattedMessage id="campaign_pay_it_forward.you_must" />&nbsp;
      <Link to="/signup" onClick={onClick}>
        <FormattedMessage id="campaign_pay_it_forward.signup" />
      </Link>
      &nbsp;<FormattedMessage id="main.or" />&nbsp;
      <Link to="/login" onClick={onClick}>
        <FormattedMessage id="main.login" />
      </Link>
      &nbsp;
      <FormattedMessage id="campaign_pay_it_forward.to_forward" />
    </div>
  </StyledSignAndLogin>
);

SignAndLogin.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

SignAndLogin.defaultProps = {
  className: '',
};

export default memo(SignAndLogin);
